import { StudyEntityType, StudyPopulation } from '@faro/study-designer-model';
import { createStudyEntityHookFactory } from '../createStudyEntityHookFactory';
import { studyPopulationClient } from './StudyPopulationClient';

const factory = createStudyEntityHookFactory<StudyPopulation>(StudyEntityType.StudyPopulation);

export const useStudyPopulations = factory.list(studyPopulationClient.list);
export const useUpdateStudyPopulation = factory.mutate(studyPopulationClient.update);
